<template>
	<div class="">
		<div class="text-center text-ihh-midnight-gray text-2xl lg:text-3xl font-semibold tracking-widest pb-6">Popular Products</div>

		<ImageScroller :sideButtons="true">
			<router-link
				:to="`/products/${p?.customUrl?.url?.replace('/', '')?.trim() || p.id}`"
				class="relative overflow-hidden rounded-lg snap-start w-[calc((100%-1rem)/2)] xs:w-[calc((100%-1rem)/3)] sm:w-[calc((100%-2rem)/4)] lg:w-[calc((100%-3rem)/6)] shrink-0"
				v-for="p in popular"
				:key="p.id"
			>
				<div class="cursor-pointer">
					<img :src="p.images?.find((i) => i.isThumbnail)?.url || p.images?.[0]?.url" :alt="p?.alt" class="object-center object-cover w-full aspect-square" />
				</div>
				<div class="mt-4 flex w-full justify-center text-center text-sm font-semibold px-4 rounded py-px tracking-wide text-ihh-midnight-gray">
					{{ p.name }}
				</div>
				<div class="text-base text-ihh-gray-200 flex text-center w-full justify-center px-4 my-2"></div>
			</router-link>
		</ImageScroller>

		<!-- <div class="flex w-full justify-center mt-6">
			<button
				class="text-xl text-white font-semibold tracking-widest bg-ihh-dark-green px-6 py-2.5 transition ease-in-out hover:bg-ihh-light-lavendar border border-ihh-dark-green rounded-xl hover:text-ihh-dark-green"
			>
				Shop Best Sellers
			</button>
		</div> -->
	</div>
</template>

<script>
import Mango from '../../../helpers/mango'
import ImageScroller from './image-scroller.vue'

export default {
	components: { ImageScroller },
	data() {
		return {
			popular: [],
			popularBcIds: [862, 1314, 551, 630, 2022, 3340, 3866, 3912, 3916],
		}
	},
	async created() {
		let fields = ['id', 'name', 'customUrl', 'images', 'alt', 'rating', 'bcId']
		let response = await Mango.products({ search: { bcId: { $in: this.popularBcIds } }, limit: 10, fields })
		response = response.sort((a, b) => this.popularBcIds.indexOf(a.bcId) - this.popularBcIds.indexOf(b.bcId))
		this.popular = response
	},
}
</script>
